const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_region: "us-east-1",
  aws_user_pools_id: "us-east-1_Ka8BisfMl",
  aws_user_pools_web_client_id: "43akkkq6pq9mhegmu0ibm4a58g",
  oauth: {
    domain: "auth.focused.space",
    scope: [],
    redirectSignIn: "https://admin.focused.space, http://localhost:8686",
    redirectSignOut: "https://admin.focused.space, http://localhost:8686",
    responseType: "code",
  },
  aws_cognito_social_providers: ["GOOGLE", "APPLE"],
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: [],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  aws_mandatory_sign_in: "enable",
};

export default awsmobile;
